import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import moment from "moment";

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// import VueExcelEditor from "vue-excel-editor";
// Vue.use(VueExcelEditor)

Vue.config.productionTip = false

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

//se https://forum.vuejs.org/t/how-to-format-date-for-display/3586/3
Vue.filter('formatDate', function (value:any) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
});

Vue.filter('formatDateTime', function (value:any) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm')
  }
});

Vue.filter('toCurrency', function (value:any) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});
Vue.filter('formatRound', function(value:any, decimals:number) {
  if(!value) {
    value = 0;
  }

  if(!decimals) {
    decimals = 0;
  }

  return value.toFixed(decimals);

  // value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  // return value;
});


new Vue({
 
  router,
  render: h => h(App)
}).$mount('#app')

Vue.use(require('vue-shortkey'), { prevent: ['input', 'textarea'] });
